<script lang="ts">
  import type { PageProps } from "./$types";
  import FixedPriceContract from "./FixedPriceContract.svelte";
  import MetaData from "$lib/MetaData.svelte";

  let { data }: PageProps = $props();
  let title = $derived(data.fixedPriceContent?.contract?.name || "Fastpris");
  let description = $derived(
    data.fixedPriceContent?.contract?.description ||
      "Sikre deg mot de store svingningene i spotprisen ved å binde strømprisen."
  );
</script>

<MetaData
  data={{
    title,
    description,
  }}
/>

<h1 class="text-base font-normal font-body after:content-['.']">{description}</h1>
<FixedPriceContract content={data.fixedPriceContent} fixedPrices={data.fixedPrices} />
